import * as React from 'react';

const FlatwareSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M17 14h-2V3.2c.9.3 2 1.3 2 3.8v7zm-1 7h-1v-6h1v6zM14 2v20h3v-7h1V7c0-2.8-1.2-5-4-5zM11 10V2h-1v4H9V2H8v4H7V2H6v8h2v4H7v8h3v-8H9v-4h2zM9 21H8v-6h1v6zM7 9V7h3v2H7z" />
    </svg>
);

FlatwareSvg.displayName = 'FlatwareSvg';
export default FlatwareSvg;
